import React from 'react';
import StatusOval from '../components/StatusOval';

const svgStyle = {display: 'block', fontFamily: "'Geist', sans-serif", width: '100%', height: 'auto'};

const StickyNote = ({x, y, w, h, rotate, lines, fontSize}) => (
    <g transform={`translate(${x} ${y}) rotate(${rotate})`}>
        <rect width={w} height={h} rx="4" fill="#FFF1A8" stroke="#E8C547" strokeWidth="1.5"/>
        <rect width={w} height={h * 0.1} fill="#FBE37A"/>
        {lines.map((line, i) => (
            <text key={line} x={w * 0.1} y={h * 0.28 + i * (h * 0.15)} fontSize={fontSize} fontWeight="500"
                  fill="#5C4A00">{line}</text>
        ))}
    </g>
);

export const NotesIllustrationDesktop = () => (
    <svg width="520" height="240" viewBox="0 0 520 240" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="2">
            <line x1="120" y1="24" x2="120" y2="220"/>
            <line x1="260" y1="24" x2="260" y2="220"/>
        </g>
        <path d="M186 90 C 230 90, 222 150, 206 150" fill="none" stroke="#8A877E" strokeWidth="2"/>
        <StatusOval cx={120} cy={90} rx={66} ry={24} status="doing" label="Refund flow" fontSize={13}/>
        <StatusOval cx={260} cy={150} rx={66} ry={24} status="todo" label="Partial refunds" fontSize={13}/>
        <StickyNote x={330} y={40} w={150} h={140} rotate={4} fontSize={14}
                    lines={['Check with', 'finance about', 'refund limits']}/>
        <path d="M330 110 C 300 110, 300 96, 190 92" fill="none" stroke="#C9A93A" strokeWidth="1.5"
              strokeDasharray="4 4"/>
    </svg>
);

export const NotesIllustrationMobile = () => (
    <svg width="326" height="190" viewBox="0 0 326 190" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="2">
            <line x1="66" y1="14" x2="66" y2="176"/>
            <line x1="150" y1="14" x2="150" y2="176"/>
        </g>
        <path d="M112 70 C 136 70, 130 120, 116 120" fill="none" stroke="#8A877E" strokeWidth="2"/>
        <StatusOval cx={66} cy={70} rx={50} ry={19} status="doing" label="Refund flow" fontSize={11} strokeWidth={2.2}/>
        <StatusOval cx={150} cy={120} rx={50} ry={19} status="todo" label="Partial refunds" fontSize={11} strokeWidth={2.2}/>
        <StickyNote x={200} y={28} w={112} h={112} rotate={4} fontSize={12}
                    lines={['Check with', 'finance about', 'refund limits']}/>
    </svg>
);

const JiraTicketRow = ({x, y, w, h, kind, kindColor, kindBg, label, dark}) => (
    <>
        <rect x={x} y={y} width={w} height={h} rx="9" fill={dark ? '#26262B' : '#26262B'} stroke="#3A3A40"/>
        <rect x={x + 10} y={y + 9} width={kind === 'STORY' ? 46 : 38} height="16" rx="4" fill={kindBg}/>
        <text x={x + 10 + (kind === 'STORY' ? 23 : 19)} y={y + 21} fontSize="9" fontWeight="700" fill={kindColor}
              textAnchor="middle">{kind}</text>
        <text x={x + (kind === 'STORY' ? 62 : 54)} y={y + h / 2 + 5} fontWeight={kind === 'STORY' ? '600' : undefined}
              fill={kind === 'STORY' ? '#FFFFFF' : '#E6E4DC'}>{label}</text>
    </>
);

export const TicketCreationIllustrationDesktop = () => (
    <svg width="520" height="240" viewBox="0 0 520 240" aria-hidden="true" style={svgStyle}>
        <rect x="24" y="34" width="190" height="172" rx="14" fill="#26262B" stroke="#3A3A40"/>
        <text x="42" y="62" fontSize="13" fontWeight="600" fill="#FFFFFF">Checkout revamp</text>
        <StatusOval cx={90} cy={100} rx={48} ry={17} status="todo" variant="dark" label="Validate card" fontSize={11}
                    strokeWidth={2}/>
        <StatusOval cx={148} cy={142} rx={48} ry={17} status="todo" variant="dark" label="Call provider" fontSize={11}
                    strokeWidth={2}/>
        <StatusOval cx={90} cy={182} rx={48} ry={17} status="todo" variant="dark" label="Show receipt" fontSize={11}
                    strokeWidth={2}/>
        <g fill="none" stroke="#6B6A72" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M226 120 H 262"/>
            <path d="M255 113 L262 120 L255 127"/>
        </g>
        <text x="274" y="30" fontFamily="'Geist Mono', monospace" fontSize="11" letterSpacing="0.1em" fill="#8A887F">
            JIRA
        </text>
        <g fontSize="13">
            <JiraTicketRow x={274} y={42} w={222} h={40} kind="STORY" kindColor="#8DB4FF" kindBg="#23324D"
                           label="Checkout revamp"/>
            <JiraTicketRow x={294} y={90} w={202} h={36} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Validate card"/>
            <JiraTicketRow x={294} y={134} w={202} h={36} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Call provider"/>
            <JiraTicketRow x={294} y={178} w={202} h={36} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Show receipt"/>
        </g>
        <path d="M284 82 V 196 M284 108 H 294 M284 152 H 294 M284 196 H 294" fill="none" stroke="#3A3A40"
              strokeWidth="1.5"/>
    </svg>
);

export const TicketCreationIllustrationMobile = () => (
    <svg width="326" height="210" viewBox="0 0 326 210" aria-hidden="true" style={svgStyle}>
        <rect x="10" y="24" width="124" height="166" rx="12" fill="#26262B" stroke="#3A3A40"/>
        <text x="22" y="46" fontSize="11" fontWeight="600" fill="#FFFFFF">Checkout revamp</text>
        <StatusOval cx={66} cy={80} rx={44} ry={15} status="todo" variant="dark" label="Validate card" fontSize={10}
                    strokeWidth={1.8}/>
        <StatusOval cx={80} cy={120} rx={44} ry={15} status="todo" variant="dark" label="Call provider" fontSize={10}
                    strokeWidth={1.8}/>
        <StatusOval cx={66} cy={160} rx={44} ry={15} status="todo" variant="dark" label="Show receipt" fontSize={10}
                    strokeWidth={1.8}/>
        <g fill="none" stroke="#6B6A72" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M140 106 H 156"/>
            <path d="M151 101 L156 106 L151 111"/>
        </g>
        <text x="164" y="18" fontFamily="'Geist Mono', monospace" fontSize="10" letterSpacing="0.1em" fill="#8A887F">
            JIRA
        </text>
        <g fontSize="11">
            <JiraTicketRow x={164} y={28} w={154} h={36} kind="STORY" kindColor="#8DB4FF" kindBg="#23324D"
                           label="Checkout revamp"/>
            <JiraTicketRow x={176} y={74} w={142} h={34} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Validate card"/>
            <JiraTicketRow x={176} y={116} w={142} h={34} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Call provider"/>
            <JiraTicketRow x={176} y={158} w={142} h={34} kind="TASK" kindColor="#B4B2AA" kindBg="#2E2E34"
                           label="Show receipt"/>
        </g>
        <path d="M169 64 V 175 M169 91 H 176 M169 133 H 176 M169 175 H 176" fill="none" stroke="#3A3A40"
              strokeWidth="1.5"/>
    </svg>
);
